// extracted by mini-css-extract-plugin
export default {"wrapper":"Meta_wrapper__+kc5F"};